import React from "react";
import styles from "./Heading.module.scss";
import AnimateTitle from "@/components/common/AnimateTitle";
import { eyebrowTone } from "@/config/site";

/**
 *
 * Heading
 *
 */
const Heading = ({
  as = "h2",
  textSize = "text-h2",
  bottomBorder = false,
  // Short gold line under the title (Card style); replaces the gray rule.
  accent = false,
  align = "left",
  isContainer = false,
  // Small caps line tight above the title.
  eyebrow = null,
  backgroundColor = undefined,
  children,
  ...props
}: any) => {
  return (
    <div className={`${isContainer ? "container mx-auto" : ""}`}>
      {eyebrow && (
        <Eyebrow backgroundColor={backgroundColor} align={align}>
          {eyebrow}
        </Eyebrow>
      )}
      <AnimateTitle
        as={as}
        title={children}
        className={`${styles.heading} ${textSize} ${align === "center" ? "justify-center" : ""} text-balance font-hero font-400 ${bottomBorder && !accent ? "pb-12 border-b-2 border-[#96A2A1]" : ""}`}
        {...props}
      />
      {accent && <GoldAccent align={align} />}
    </div>
  );
};

/** Small spaced caps above a title. Spacing is fixed; color comes from the tokens. */
export const Eyebrow = ({
  backgroundColor,
  align = "left",
  children,
}: {
  backgroundColor?: string;
  align?: string;
  children: React.ReactNode;
}) => (
  <p
    className={`text-label mb-2 ${eyebrowTone(backgroundColor)} ${align === "center" ? "text-center" : ""}`}
  >
    {children}
  </p>
);

/** The short gold rule used under Card titles and, optionally, block titles. */
export const GoldAccent = ({ align = "left" }: { align?: string }) => (
  <div
    aria-hidden="true"
    className={`bg-gold h-[5px] w-[35px] mt-6 ${align === "center" ? "mx-auto" : ""}`}
  />
);

export default Heading;
